import { create } from 'zustand';
export const useQueryContextStore = create()((set) => ({
    endpoint: '',
    setEndpoint: (endpoint) => set(() => ({
        endpoint,
    })),
}));
//# sourceMappingURL=useQueryContextStore.js.map